/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProductTypeDto model module.
 * @module model/ProductTypeDto
 * @version v1.0.0
 */
class ProductTypeDto {
    /**
     * Constructs a new <code>ProductTypeDto</code>.
     * @alias module:model/ProductTypeDto
     */
    constructor() { 
        
        ProductTypeDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProductTypeDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProductTypeDto} obj Optional instance to populate.
     * @return {module:model/ProductTypeDto} The populated <code>ProductTypeDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProductTypeDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * id
 * @member {String} id
 */
ProductTypeDto.prototype['id'] = undefined;

/**
 * name
 * @member {String} name
 */
ProductTypeDto.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
ProductTypeDto.prototype['seq'] = undefined;






export default ProductTypeDto;

